import React from "react";
import Sections from "./partials/Sections";
import Label from "./partials/Label";
import {IGridConfigItem} from "../../../constants/interfaces";
import PaidType from "./partials/PaidType";
import VideoFilter from "./partials/VideoFilter";
import TimeWindow from "./partials/TimeWindow";
import PostedOnChannel from "./partials/PostedOnChannel";
import Tags from "./partials/Tags";
import PageType from "./partials/PageType";

type Props = {
	item: IGridConfigItem,
	updateConfig: Function,
	isEdit: boolean,
	removeItem: React.MouseEventHandler<HTMLButtonElement>,
	id: number
}

const NotificationCenter = (props: Props) => {
	return (
		<div className="config-item__list">
			<h2>Notification centre</h2>

			<Sections
				updateConfig={props.updateConfig}
				sections={props.item.sections}
				brands={props.item.brands}
				type="feed"
				isEdit={props.isEdit}
				cellId={props.item.cell_id}
				id={props.id}
			/>

			<div className="config-item__selects">
				<Tags
					updateConfig={props.updateConfig}
					tags={props.item.tags}
					brands={props.item.brands}
					type="feed"
					isEdit={props.isEdit}
					isDisabled={props.item.brands.length === 0}
					cellId={props.item.cell_id}
					id={props.id}
				/>
			</div>

			<div className="config-item__selects">
				<TimeWindow updateConfig={props.updateConfig} timeWindow={props.item.time_window} timeFrameType="12hours" />
			</div>

			<div className="config-item__selects">
				<PaidType updateConfig={props.updateConfig} value={props.item.paid_type} />
				<VideoFilter updateConfig={props.updateConfig} value={props.item.video_filter} />
				<PageType updateConfig={props.updateConfig} value={props.item.page_type} />
			</div>

			<PostedOnChannel
				isEdit={props.isEdit}
				postedOnChannels={props.item.posted_on_channels}
				updateConfig={props.updateConfig}
			/>

			<Label updateConfig={props.updateConfig} value={props.item.label}/>
			<button
				className="btn btn-outline-danger remove-item"
				onClick={props.removeItem}
			>
				Remove
			</button>
		</div>
	);
};

export default NotificationCenter;
